import React from "react";
import { CTAButton, SectionLabel, Reveal } from "@/lib/uiHelpers";
import { FINANCING } from "@/constants/landingCopy";
import { Check } from "lucide-react";

function FinancingCard({ opt }) {
  return (
    <div
      className="h-full flex flex-col rounded-2xl bg-white p-7 md:p-8"
      style={{ borderTop: `5px solid ${opt.accent}`, boxShadow: "0 18px 44px -28px rgba(26,43,74,0.3)" }}
    >
      <span
        className="font-head inline-block self-start rounded-full px-3 py-1 text-xs font-extrabold uppercase"
        style={{ background: `${opt.accent}1f`, color: opt.accent, letterSpacing: "0.08em" }}
      >
        {opt.badge}
      </span>
      <h3 className="font-head font-extrabold text-2xl mt-4" style={{ color: "#1A2B4A" }}>{opt.name}</h3>
      <p className="font-body text-sm mt-1" style={{ color: "#7F8C8D" }}>{opt.partner}</p>

      <ul className="mt-5 space-y-3 flex-1">
        {opt.points.map((p) => (
          <li key={p} className="flex items-start gap-2.5">
            <span
              className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full"
              style={{ background: `${opt.accent}26` }}
            >
              <Check size={13} strokeWidth={3} style={{ color: opt.accent }} />
            </span>
            <span className="font-body text-sm md:text-base" style={{ color: "#2C3E50" }}>{p}</span>
          </li>
        ))}
      </ul>

      <p className="font-body text-xs italic mt-6 pt-5" style={{ color: "#9aa4a6", borderTop: "1px solid #ece7dc" }}>
        {opt.note}
      </p>
    </div>
  );
}

export default function Financing() {
  return (
    <section className="section-pad" style={{ backgroundColor: "#FAFAF8" }}>
      <div className="container-max">
        <Reveal className="text-center max-w-2xl mx-auto">
          <SectionLabel>How You Pay For It</SectionLabel>
          <h2 className="font-head font-extrabold text-3xl md:text-5xl" style={{ color: "#1A2B4A" }}>
            Two Ways to Fund Your Solar
          </h2>
          <p className="font-body mt-4 text-base md:text-lg" style={{ color: "#7F8C8D" }}>
            Every homeowner is different. We&apos;ll help you choose the path that fits your goals on
            your free discovery call &mdash; no pressure either way.
          </p>
        </Reveal>

        <div className="mt-12 grid md:grid-cols-2 gap-6 items-stretch">
          {FINANCING.map((opt, i) => (
            <Reveal key={opt.name} delay={i * 0.1}>
              <FinancingCard opt={opt} />
            </Reveal>
          ))}
        </div>

        <div className="mt-10 text-center">
          <CTAButton testId="financing-cta" variant="gold" className="w-full sm:w-auto">
            &rarr; Find My Best Option &mdash; Book My Call
          </CTAButton>
        </div>
      </div>
    </section>
  );
}
